import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { DisabilyUploadComponent } from './components/disabily-upload/disabily-upload.component';
import { DisabilyCorrectComponent } from "./components/disabily-correct/disabily-correct.component";

const routes: Routes = [
  { path: "incapacidades", component: DisabilyUploadComponent },
  { path: "incapacidades-subsanar/:id", component: DisabilyCorrectComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class DisabilityRoutingModule { }



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/disability/disability-routing.module.ts